import PropTypes from "prop-types";
import { Container } from "@mui/material";

import CategoryPresenter from "presenters/CategoryPresenter";
import appRoutes from "routes/appRoutes";

import CategoryPills from "../CategoryPills/CategoryPills";

const CategoryCollection = ({ categories, loading }) => {
  const items = categories?.map((category, index) => {
    return {
      desktopImage: CategoryPresenter.fullImage(category),
      id: CategoryPresenter.id(category),
      name: CategoryPresenter.displayName(category),
      rank: index,
      type: "pills",
      url: appRoutes.invitePath(CategoryPresenter.id(category)),
      newEntry: "",
    };
  });

  return (
    <Container>
      <CategoryPills items={items} loading={loading} />
    </Container>
  );
};

CategoryCollection.propTypes = {
  categories: PropTypes.arrayOf(CategoryPresenter.shape()),
  loading: PropTypes.bool,
};

export default CategoryCollection;
